import log from 'loglevel'
import axios from 'axios'
import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Classifier {
  constructor() {
    log.info('[INFO] Initialize Classifier  SubModule')
    this.cache = new Cache()
  }

  fetchClassifiers(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/product/classifiers/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch classifiers')
            resolve(response.data)
          })
          .catch(err => {
            log.error('[ERROR] Fail to fetch classifiers')
            log.error(err)
            reject(err.response)
          })
      })

      return promise
    })

    return result
  }

  fetchClassifier(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/product/classifiers/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch classifier')
          resolve(response.data)
        })
        .catch(err => {
          log.error('[ERROR] Fail to fetch classifier')
          log.error(err)
          reject(err.response)
        })
    })
  }

  updateClassifier(id, classifierData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/product/classifiers/${id}/`, classifierData)
        .then(response => {
          log.debug('[DEBUG] Success to update classifier')
          this.cache.reset()
          resolve(response)
        })
        .catch(err => {
          log.error('[ERROR] Fail to update classifier')
          log.error(err)
          reject(err.response)
        })
    })
  }

  addClassifier(classifierData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/product/classifiers/', classifierData)
        .then(response => {
          log.debug('[DEBUG] Success to add classifier')
          this.cache.reset()
          resolve(response)
        })
        .catch(err => {
          log.error('[ERROR] Fail to add classifier')
          log.error(err)
          reject(err.response)
        })
    })
  }

  deleteClassifier(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/product/classifiers/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete classifiers with id:', id)
          this.cache.reset()
          resolve()
        })
        .catch(err => {
          log.error('[ERROR] Fail to delete classifiers')
          log.error(err)
          reject(err.response)
        })
    })
  }
}
